export default "__VITE_ASSET__CxmqYEnj__"